import {
	SiHtml5,
	SiCss3,
	SiTypescript,
	SiNextdotjs,
	SiPhp,
	SiFirebase,
	SiWordpress,
	SiCentos,
	SiUbuntu,
	SiJavascript,
	SiWebpack,
	SiTailwindcss,
	SiGreensock,
} from "react-icons/si";
import { FaSass, FaNodeJs, FaGulp } from "react-icons/fa";
import { DiReact, DiNpm, DiGitBranch } from "react-icons/di";
import { AiOutlineConsoleSql, AiOutlineGithub } from "react-icons/ai";
import { GrDocker } from "react-icons/gr";

export const frontSkills = [
	{
		id: 1,
		title: "HTML5",
		rate: "☆☆☆☆☆",
		icon: SiHtml5,
	},
	{
		id: 2,
		title: "CSS3",
		rate: "☆☆☆☆☆",
		icon: SiCss3,
	},
	{
		id: 3,
		title: "SASS",
		rate: "☆☆☆☆☆",
		icon: FaSass,
	},
	{
		id: 4,
		title: "Tailwind",
		rate: "☆☆☆☆",
		icon: SiTailwindcss,
	},
	{
		id: 5,
		title: "Javascript",
		rate: "☆☆☆☆☆",
		icon: SiJavascript,
	},
	{
		id: 6,
		title: "React.js",
		rate: "☆☆☆☆☆",
		icon: DiReact,
	},
	{
		id: 7,
		title: "Typescript",
		rate: "☆☆☆",
		icon: SiTypescript,
	},
	{
		id: 8,
		title: "Next.js",
		rate: "☆☆",
		icon: SiNextdotjs,
	},
	{
		id: 9,
		title: "Greensock",
		rate: "☆☆",
		icon: SiGreensock,
	},
];

export const backendSkills = [
	{
		id: 1,
		title: "Node.js",
		rate: "☆",
		icon: FaNodeJs,
	},
	{
		id: 2,
		title: "MySQL",
		rate: "☆☆",
		icon: AiOutlineConsoleSql,
	},
	{
		id: 3,
		title: "PHP",
		rate: "☆☆☆",
		icon: SiPhp,
	},
	{
		id: 4,
		title: "firebase",
		rate: "☆☆",
		icon: SiFirebase,
	},
	{
		id: 5,
		title: "WordPress",
		rate: "☆☆☆☆",
		icon: SiWordpress,
	},
];

export const toolSkills = [
	{
		id: 1,
		title: "ubuntu",
		rate: "☆",
		icon: SiUbuntu,
	},
	{
		id: 2,
		title: "centOS",
		rate: "☆",
		icon: SiCentos,
	},
	{
		id: 3,
		title: "docker",
		rate: "☆☆☆",
		icon: GrDocker,
	},
	{
		id: 4,
		title: "gulp",
		rate: "☆☆",
		icon: FaGulp,
	},
	{
		id: 5,
		title: "Webpack",
		rate: "☆☆",
		icon: SiWebpack,
	},
	{
		id: 6,
		title: "npm",
		rate: "☆☆☆",
		icon: DiNpm,
	},
	{
		id: 7,
		title: "git",
		rate: "☆☆☆",
		icon: DiGitBranch,
	},
	{
		id: 8,
		title: "Github",
		rate: "☆☆☆",
		icon: AiOutlineGithub,
	},
];
